<template>
  <el-dialog :visible.sync="state" :title="plustitle" width="600px" custom-class="c-media-edit" :close-on-click-modal="false">
    <div class="media-edif-form">
      <el-form ref="mediaEditForm" :model="mediaData" :rules="ruleValidate" label-width="160px">
        <el-form-item label="媒体ID" prop="mediaId" v-if="editFlag === 'edit'">
          <el-input v-model="mediaData.mediaId" style="width: 320px" :disabled="true" />
        </el-form-item>
        <el-form-item label="媒体名称" prop="mediaName">
          <el-input v-model="mediaData.mediaName" placeholder="请输入媒体名称" :maxlength="50" style="width: 320px" />
        </el-form-item>
        <el-form-item label="默认投放位名称" prop="adsName" v-if="editFlag === 'add'">
          <el-input v-model="mediaData.adsName" placeholder="请输入默认投放位名称" :maxlength="50" style="width: 320px" />
        </el-form-item>
        <el-form-item label="登录地址" prop="loginAddr">
          <el-input v-model="mediaData.loginAddr" placeholder="请输入登录地址" :maxlength="200" style="width: 320px" />
        </el-form-item>
        <el-form-item label="媒体汇率" prop="rebate">
          <el-input
            type="number"
            placeholder="请输入媒体汇率"
            v-model="mediaData.rebate"
            :max="100"
            :min="0"
            :step="0.1"
            style="width: 320px"
            clearable
          />
        </el-form-item>
      </el-form>
    </div>
    <template slot="footer">
      <div class="m-foot">
        <el-button @click="$emit('input', false)">取消</el-button>
        <el-button type="primary" :loading="loading" @click="save">
          <span v-if="loading">提交中...</span>
          <span v-else>确认</span>
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script>
export default {
  name: 'mediaEdit',
  props: {
    value: {
      type: Boolean
    },
    title: {
      type: String
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    editData: {
      type: Object
    },
    editFlag: {
      type: String
    }
  },
  data() {
    var checkMediaName = (rule, value, callback) => {
      if (!value || value.trim() === '') {
        return callback(new Error('媒体名称不能为空'))
      }
      return callback()
    }
    var checkAdsName = (rule, value, callback) => {
      if (this.editFlag === 'add') {
        if (!value || value.trim() === '') {
          return callback(new Error('默认投放位名称不能为空'))
        }
      }
      return callback()
    }
    return {
      mediaData: {
        mediaId: null,
        mediaName: '',
        adsName: '',
        loginAddr: '',
        rebate: 1
      },
      ruleValidate: {
        mediaName: [{ required: true, validator: checkMediaName, trigger: 'blur' }],
        adsName: [{ required: true, validator: checkAdsName, trigger: 'blur' }]
      }
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    plustitle() {
      return `${this.editFlag === 'edit' ? '修改' : '新建'}${this.title}`
    }
  },
  watch: {
    editData: {
      handler(nVal) {
        this.updateInfo()
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.updateInfo()
    })
  },
  methods: {
    updateInfo() {
      this.$refs.mediaEditForm.resetFields()
      const info = JSON.parse(JSON.stringify(this.editData))
      this.mediaData.mediaId = info.mediaId
      this.mediaData.mediaName = info.mediaName
      this.mediaData.adsName = info.adsName
      this.mediaData.loginAddr = info.loginAddr
      this.mediaData.rebate = info.rebate
    },
    // 提交验证
    save() {
      this.$refs.mediaEditForm.validate((valid) => {
        if (valid) {
          this.$emit('on-save', this.mediaData)
        } else {
          this.$message.error('表单验证失败!')
        }
      })
    }
  }
}
</script>
